import React from "react";
import Offers from "./Offers/Offers";
import Layout from "../Layout/Layout";

const MainPage = () => {
  return (
    <>
      <Layout>
        <Offers />
      </Layout>
    </>
  );
};

export default MainPage;
